export default __webpack_public_path__ + "static/media/dapat-dark.6c03f014.svg";